import React from "react"

import InputsWithoutValidate from "Components/UI/Molecules/InputsWithoutValidate"
import CustomButton from "Components/UI/Atoms/CustomButton"
import { interfaces } from "service/interfaces"

import { FIELDS } from "./Fields"
import useCustomSnackbar from "Components/UI/Atoms/SnackBar"
import useStyles from "../../../Quotations/Edit/Fields/Home/styles"
import { printPDF } from "Helpers"
import SetState from "Components/Hooks/SetState"
import DialogComponent from "Components/UI/Molecules/Modals/DialogComponent"
import CancelConfirmButtons from "Components/UI/Molecules/CancelConfirmButtons"

export const Home = (props) => {
  const {
    data,
    setData,
    edit,
    permissions,
    setIsLoading,
    setRender,
    render,
    handleclose,
    wafers,
  } = props
  
  const classes = useStyles()

  const { state, setOpen, setClose } = SetState()
  const {
    state: stateFinalize,
    setOpen: setOpenFinalize,
    setClose: setCloseFinalize,
  } = SetState()
  
  const handleChange = (name, value) => {
    setData({
      ...data,
      [name]: value,
    })
  }
  const createDismissableSnackbar = useCustomSnackbar()

  const finalize = async () => {
    setIsLoading(true)
    setCloseFinalize()
    await interfaces.wafersWithControlInterface
      .finalize(data.id)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: "success",
        })
        setRender(!render)
        handleclose()
      })
      .catch(() => {
        createDismissableSnackbar("Error", {
          variant: "error",
        })
      })
    handleclose()
    setIsLoading(false)
  }

  const download = async () => {
    createDismissableSnackbar("Aguarde un momento, se está descargando el archivo...", {
      variant: "info",
    })
    setIsLoading(true)
    setClose()
    await interfaces.wafersWithControlInterface
      .download(data.vehiculo_id)
      .then((res) => {
        printPDF(res, 500, 800).print()
        createDismissableSnackbar("Descarga completada con éxito!", {
          variant: "success",
        })
      })
      .catch(() => {
        createDismissableSnackbar("Algo salió mal!", {
          variant: "error",
        })
      })
    setIsLoading(false)
  }
  return ( 
    <>
      <div style={{padding: "3em"}} >
        <InputsWithoutValidate
          fields={FIELDS(data, handleChange, edit)}
          spacing={2}
        />
        <div className={classes.buttons}>
          <CustomButton
            buttonEnd
            style={{
              marginTop: "10px",
              marginLeft: "1.5rem",
            }}
            text="Finalizar"
            disabled={!(permissions.engineerInterface && data.estado !== "Revisión finalizada")}
            onClick={(e) => setOpenFinalize()}            
          />  
          <CustomButton
            buttonEnd
            style={{
              marginTop: "10px",
              marginLeft: "1.5rem",
              backgroundColor: data.estado !== "Revisión finalizada" || !wafers.some(w => w.oblea === 0) ? "#e0e0e0ff" : "#797878"
            }}
            text="Imprimir informe"
            disabled={data.estado !== "Revisión finalizada" || !wafers.some(w => w.oblea === 0)}
           // onClick={(e) => download()}
            onClick={() => setOpen()}
          />  
        </div>

        {state.suspense && (
          <DialogComponent
            open={state.open}
            handleclose={state.loading ? null : setClose}
            widthLarge={500}
            title="¿Desea descargar el informe?"
            disableChildHeight
            disableBackdropClick
            disableEscapeKeyDown
            actions={
              <CancelConfirmButtons
                onClickSubmit={(e) => download()}
                disabledCancel={state.loading}
                disabledSubmit={state.loading}
                isLoading={state.loading}
              />
            }
          />
        )}     

        {stateFinalize.suspense && (
            <DialogComponent
              open={stateFinalize.open}
              handleclose={stateFinalize.loading ? null : setCloseFinalize}
              widthLarge={500}
              title="¿Desea finalizar este vehículo?"
              subtitle="¡Esta acción es irreversible!"
              disableChildHeight
              disableBackdropClick
              disableEscapeKeyDown
              actions={
                <CancelConfirmButtons
                  onClickSubmit={(e) => finalize()}
                  disabledCancel={stateFinalize.loading}
                  disabledSubmit={stateFinalize.loading}
                  isLoading={stateFinalize.loading}
                />
              }
            />
        )}   
      </div>
    </>
  )
}
